import React from 'react';

import FormattedMessage from 'components/formatted-message';

import styles from '../../auth.module.css';

/** "Forgot Password?" and "Account Locked?" under the login fields: the pages of the signed-out user */
const AuthHelpLinks = () => (
    <div className={styles.linksRow}>
        <a href="/forgot-password">
            <FormattedMessage id="forgotPassword.link" />
        </a>
        <a href="/request-unlock">
            <FormattedMessage id="requestUnlock.link" />
        </a>
    </div>
);

export default AuthHelpLinks;
